export default "__VITE_ASSET__JM3CD8f5__"